import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the address.
 **/
export const TextFieldAddress = ({ values, handleChange, errors, touched }) => (
    <TextField
        fullWidth
        label={t('users.fields.address')}
        name="address"
        value={values.address}
        error={touched.address && Boolean(errors.address)}
        helperText={touched.address && errors.address}
        onChange={handleChange}
    />
);

TextFieldAddress.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
